function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { eventHelper } from "./EventHelper";
import { rune } from "./rune";
import { _camelToColonSeparated } from "./lib/_camelToColonSeparated";
export class Base {
    onRender() {}
    _onRender() {
        rune.set(this.element(), this);
        eventHelper.addDecoratedListeners(this, this.element());
        this.onRender();
        eventHelper.addReservedListener(this, this.element());
        return this;
    }
    onMount() {}
    _onMount() {
        this.onMount();
        return this;
    }
    onUnmount() {}
    _onUnmount() {
        this.onUnmount();
        return this;
    }
    element() {
        if (this._element === null) {
            throw new TypeError("element is not created. call 'view.render' or 'view.hydrateFromSSR'.");
        }
        return this._element;
    }
    isRendered() {
        return this._element !== null;
    }
    chain(f) {
        f.call(this, this);
        return this;
    }
    async chainAsync(f) {
        await f.call(this, this);
        return this;
    }
    safely(f) {
        return this.isRendered() ? this.chain(f) : this;
    }
    async safelyAsync(f) {
        return this.isRendered() ? this.chainAsync(f) : this;
    }
    _getElId() {
        if (this.element().id) {
            return this.element().id;
        } else {
            this._isTempElId = true;
            return this.element().id = "rune-temp-id-".concat(++this._runeElNumber);
        }
    }
    _removeTempElId() {
        if (this._isTempElId) {
            this.element().removeAttribute("id");
            this._isTempElId = false;
        }
        return this;
    }
    _setElement(element) {
        this._element = element;
        return this;
    }
    addEventListener(eventType, listener, options) {
        eventHelper.addEventListener(this, this._element, eventType, listener, options);
        return this;
    }
    removeEventListener(eventType, listener, options) {
        eventHelper.removeEventListener(this, this._element, eventType, listener, options);
        return this;
    }
    delegate(eventType, selector, listener) {
        eventHelper.delegate(this, this._element, eventType, selector, listener);
        return this;
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */ _createEvent(EventClass, options) {
        return new EventClass(_camelToColonSeparated(EventClass.name), options);
    }
    dispatchEvent(event, eventInitDict) {
        if (event instanceof Event) {
            this.element().dispatchEvent(event);
        } else {
            this.element().dispatchEvent(this._createEvent(event, eventInitDict));
        }
        return this;
    }
    toString() {
        return this.constructor.name;
    }
    static toString() {
        return this.name;
    }
    constructor(){
        _define_property(this, "_element", null);
        _define_property(this, "_runeElNumber", 0);
        _define_property(this, "_isTempElId", false);
    }
}
